export default {
    SET_FONTSIZE(state, data){
        state.dataSetting.fontSize = data ;
    },
    SET_FONTNAME(state, data){
        state.dataSetting.fontName = data ;
    },
    SET_NAMAALMARHUM(state, data){
        state.dataSetting.namaAlmarhum = data ;
    },
    SET_KATAGANTI(state, data){
        state.dataSetting.kataganti = data ;
    },
    SET_SETTING(state, data){
        state.dataSetting.fontSize = data.fontSize ;
        state.dataSetting.fontName = data.fontName ;
        state.dataSetting.namaAlmarhum = data.namaAlmarhum ;
        state.dataSetting.kataganti = data.kataganti ;
    },
    GET_FONTSIZE(state){
        return state.dataSetting.fontSize ;
    },
    GET_FONTNAME(state){
        return state.dataSetting.fontName ;
    },
    GET_NAMAALMARHUM(state){
        return state.dataSetting.namaAlmarhum ;
    },
    GET_KATAGANTI(state){
        return state.dataSetting.kataganti ;
    },
    GET_SETTING(state) {
        return state.dataSetting ;
    }
}